import { render, staticRenderFns } from "./Lockscreen.vue?vue&type=template&id=fb433aa6&scoped=true&"
import script from "./Lockscreen.vue?vue&type=script&lang=js&"
export * from "./Lockscreen.vue?vue&type=script&lang=js&"
import style0 from "./Lockscreen.vue?vue&type=style&index=0&id=fb433aa6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb433aa6",
  null
  
)

export default component.exports